import { formatWeeklyReset } from "./weeklyReset";

/** A send refused because the organization reached its weekly usage limit
 * (#10130, #13284). Chat's send turns its 402 into this, carrying the instant
 * new messages are admitted again (null when the server did not say), the way
 * it turns a 409 into `InFlightTurnError`. */
export class WeeklyLimitReachedError extends Error {
  public nextReset: string | null;
  constructor(nextReset: string | null) {
    super(weeklyLimitMessage(nextReset, "messages"));
    this.name = "WeeklyLimitReachedError";
    this.nextReset = nextReset;
  }
}

/** The sentence a refused send shows: why, and until when, with the reset in
 * the viewer's local zone. "Usage" and "usage limit", never "credits" or
 * "allowance" (Hunter, 2026-09-08). Chat pauses messages; agents pause runs.
 * Without a known instant it names the weekly reset rather than inventing a
 * date. */
export function weeklyLimitMessage(
  nextReset: string | null | undefined,
  paused: "messages" | "runs"
): string {
  const base =
    "Your organization has reached its weekly usage limit. " +
    `New ${paused} are paused`;
  return nextReset
    ? `${base} until ${formatWeeklyReset(nextReset)}.`
    : `${base} until the weekly reset.`;
}
